export default __webpack_public_path__ + "static/media/Search_No_data_Found.146b42cf.svg";